import styled, { css } from 'styled-components';

export const FlexContainer = styled.div<{ sidebar?: boolean }>`
  display: flex;
  width: 100%;
  position: relative;
  top: ${({ theme }) => theme.component.navBar.root.minHeight};
  min-height: ${({ theme }) => css`calc(100vh - ${theme.component.navBar.root.minHeight})`};

  ${(props) =>
    !props.sidebar &&
    css`
      justify-content: center;
      background-color: #f9f9f9;
    `}
`;
